"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Tigran.Mkrtchyan on 5/25/2017.
 */
var MetaFieldId = /** @class */ (function () {
    function MetaFieldId(metaCategoryId, systemName, metaGroupId) {
        this.metaCategoryId = metaCategoryId;
        this.systemName = systemName;
        this.metaGroupId = metaGroupId;
    }
    MetaFieldId.prototype.getSystemName = function () {
        return this.systemName;
    };
    MetaFieldId.prototype.getMetaCategoryId = function () {
        return this.metaCategoryId;
    };
    MetaFieldId.prototype.getMetaGroupId = function () {
        return this.metaGroupId;
    };
    return MetaFieldId;
}());
exports.MetaFieldId = MetaFieldId;
//# sourceMappingURL=meta-field-id.js.map